(function($){

window.CtrlAltShortcuts = {
	'E' : function(e) {
		if ($('#edit-tool-container').length > 0 && $('#edit-tool-container:visible').length == 0) {
			$('#edit-link').mouseenter();
		}
	}
};

$(function() {
	$(document).keydown(function(e) {
		var letter = String.fromCharCode(e.which);
		var alt = e.altKey;
		var ctrl = e.ctrlKey;
		
		if (ctrl && alt && CtrlAltShortcuts[letter]) {
			e.preventDefault();
			CtrlAltShortcuts[letter](e); 
		}
	});
});

})(jQuery);
